import EnvSwitcherButton from "@/components/common/shared/buttons/navigation/EnvSwitcherButton"
import CopyURLButton from "@/components/common/shared/buttons/utility/CopyURLButton"
import profileFragment from "@/graphql/fragments/profileFragment"
import useSnackbar from "@/helpers/add-snackbar"
import { Role } from "@/types/global"
import { gql, useMutation } from "@apollo/client"
import {
  Button,
  Chip,
  Grid,
  Slide,
  Toolbar,
  Typography,
  makeStyles
} from "@material-ui/core"
import { HighlightOff } from "@material-ui/icons"
import { uniqueId } from "lodash"
import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import SwitchButton from "../util/switch/SwitchButton"
import { StopImpersonation } from "./__generated__/StopImpersonation"
import ChangeOrg from "./ChangeOrg"
import RecentPagesTracker from "./fundDocumentTypeDetails/RecentPagesTracker"

const STOP_IMPERSONATION = gql`
  mutation StopImpersonation {
    stopImpersonation {
      id
      ...profileFragment
    }
  }
  ${profileFragment}
`

const useStyles = makeStyles(theme => ({
  toolbar: {
    backgroundColor: theme.palette.secondary.main
  },
  hiddenToolbar: {
    backgroundColor: theme.palette.secondary.main,
    height: 15
  }
}))

interface Organisation {
  name: string
  id: string
  modules: string[]
}

interface User {
  organisation: Organisation | null
  originalOrganisation: Organisation | null
  role: Role
  superuser: boolean
}

type SuperUserHeaderProps = {
  user: User
}

export default function SuperUserHeader(props: SuperUserHeaderProps) {
  const { user } = props
  const history = useHistory()
  const { addSnackbar } = useSnackbar()
  const classes = useStyles()

  const [stopImpersonation] = useMutation<StopImpersonation>(STOP_IMPERSONATION)

  const handleStopImpersonation = () => {
    stopImpersonation({
      // update(cache) {
      //   cache.evict({ id: "Asset:" + assetId })
      //   cache.gc()
      // }
    })
      .then(() => addSnackbar("Stopped Impersonation"))
      .then(() => history.push("/admin/organisations"))
  }

  const HiddenKey = "HiddenSuperUser"
  const [isHidden, setIsHidden] = useState(
    JSON.parse(localStorage.getItem(HiddenKey) ?? "false")
  )
  const [isHover, setIsHover] = useState(false)

  return (
    <>
      {user?.superuser && (
        <>
          {isHidden && !isHover && (
            <div
              className={classes.hiddenToolbar}
              onMouseEnter={() => setIsHover(true)}
            />
          )}
          <>
            <Slide
              appear={false}
              direction="down"
              in={isHidden ? isHover : true}
              mountOnEnter
              unmountOnExit
            >
              <Toolbar
                className={classes.toolbar}
                onMouseLeave={() => setIsHover(false)}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent={"space-between"}
                  alignItems="center"
                  alignContent="center"
                >
                  <Grid item xs={1} sm={2}>
                    <Typography variant="h6">Super User</Typography>
                    <Typography variant="caption">
                      Current Role : {user.role}
                    </Typography>
                  </Grid>
                  {user.organisation?.id !== user.originalOrganisation?.id && (
                    <Grid
                      item
                      container
                      xs={8}
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid
                        item
                        container
                        xs={8}
                        xl={6}
                        justifyContent="space-evenly"
                        alignItems="center"
                        alignContent="center"
                      >
                        <Grid
                          item
                          container
                          xs={8}
                          xl={6}
                          justifyContent="flex-start"
                          alignContent="center"
                        >
                          <Grid item xs={12}>
                            <Typography variant="caption">
                              Org: {user.organisation?.name}
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography variant="caption">
                              ID: {user.organisation?.id}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid item container xs={4}>
                          <Grid item>
                            <ChangeOrg />
                          </Grid>
                          <Grid item>
                            <Button
                              color="inherit"
                              size="small"
                              variant="outlined"
                              onClick={handleStopImpersonation}
                              startIcon={<HighlightOff />}
                            >
                              IMP
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={4}>
                        {user?.organisation?.modules?.map(e => (
                          <Chip
                            key={uniqueId("modules_")}
                            label={e}
                            size="small"
                            variant="outlined"
                            color="secondary"
                            style={{ color: "white" }}
                          />
                        ))}
                      </Grid>
                    </Grid>
                  )}
                  <Grid
                    item
                    container
                    xs={2}
                    justifyContent="flex-end"
                    alignItems="center"
                    alignContent="center"
                  >
                    <Grid item>
                      <EnvSwitcherButton />
                    </Grid>
                    <Grid item>
                      <CopyURLButton variant="outlined" color="inherit" />
                    </Grid>
                    <Grid item>
                      <RecentPagesTracker />
                    </Grid>
                    <Grid item>
                      <SwitchButton
                        title="Hide"
                        isChecked={isHidden}
                        onChange={e => {
                          localStorage.setItem(
                            HiddenKey,
                            JSON.stringify(e.target.checked)
                          )
                          setIsHidden(e.target.checked)
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Toolbar>
            </Slide>
          </>
        </>
      )}
    </>
  )
}
